import React from 'react';
import { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
// Store
import { IRootState } from '../../../redux';
// Styles
import styles from './settingssidebar.module.scss';
// Helpers
import { isMediaSizeLG, isMediaSizeLessThanMD } from '../../../helpers/layout';
// Components
//import UserSidebar from '../UserSidebar';
import Sidebar from '../Sidebar/Sidebar';
import { ISidebarState } from '../../../redux/sidebar/interfaces';
import { IAppReadoutsState } from '../../../redux/appreadouts/interfaces';

const ViewFolders = lazy(() => import('../../ViewFolders/ViewFolders'));

interface IPageLink {
    title: string;
    link: string;
    isActive: boolean;
}

interface IOwnProps {
    title: string;
    links: IPageLink[];
}

export const SettingsSidebar = (props: IOwnProps): JSX.Element => {
    const { sidebarShown } = useSelector<IRootState, ISidebarState>(({ sidebar }) => sidebar);
    const { mediaSize } = useSelector<IRootState, IAppReadoutsState>(({ appReadouts }) => appReadouts);

    return (
        <Suspense fallback={null}>
            <Sidebar>
                {(isMediaSizeLG(mediaSize) || (!isMediaSizeLessThanMD(mediaSize) && sidebarShown)) && (
                    <>
                        <div className={[styles.title, 'px-3 pb-3'].join(' ')}>
                            <FormattedMessage id={props.title} />
                        </div>

                        {props.links.map((pageLink) => (
                            <Link
                                key={pageLink.title}
                                to={pageLink.link}
                                className={`${styles.linkItem} ${
                                    pageLink.isActive ? styles.active : ''
                                } px-3 styleless`}
                            >
                                <FormattedMessage id={pageLink.title} />
                            </Link>
                        ))}
                    </>
                )}

                {isMediaSizeLessThanMD(mediaSize) && sidebarShown && <ViewFolders />}
            </Sidebar>
        </Suspense>
    );
};
